import {secured as axios} from "../../../axios";

export class Comment {
    static async fetchComment(eventId) {
        const res = await axios.get(`/comments/${eventId}`);
        return res.data;
    }

    static async removeComment(commentId) {
        const res = await axios.delete(`/comment/remove/${commentId}`);
        return res.data;
    }

    static async postComment(text,eventId) {
        const res = await axios.post(`/comment/event/${eventId}/add`,{text});
        return res.data;
    }
}